import Controller from "csi/action/Controller";
import locale from "csi/locale";
import PostRequest from "csi/comm/PostRequest";
import lang from "dojo/_base/lang";
import declare from "dojo/_base/declare";

const KeycloakUsersSynchronizeController = declare(Controller, {
	successMsg: "",

	/**
	 * @override
	 * Issue request so as to be able to receive return value.
	 */
	process: function() {
		const req = this.m_action.m_request;
		this.setProgress();
		const postRequest = new PostRequest(req.m_module, req.m_operation);
		postRequest.post({}).then(lang.hitch(this, this._onPublishResponse));
	},

	/**
	 * @override
	 * Post process success m_response to update the message
	 */
	postProcessSuccess: function() {
		const v = this.m_response;
		const syncReport = v.getResultNode();
		const total = syncReport.failureCount + syncReport.successCount;
		// generate success message
		if (syncReport.failureCount == 0){
			this.successMsg = locale.resource("SynchronizeKeycloakUsersSuccess", [total]);
		} else {
			this.successMsg = locale.resource("SynchronizeKeycloakUsersWarning", [syncReport.successCount, total]);
		}
		return this.inherited(arguments);
	},

	/**
	 * @override
	 * Get success message
	 */
	getSuccess: function() {
		return this.successMsg;
	},

});

export = KeycloakUsersSynchronizeController;